import { render } from "./AvailableServicesSection.vue?vue&type=template&id=40d9c128"
import script from "./AvailableServicesSection.vue?vue&type=script&lang=js"
export * from "./AvailableServicesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__